import { CtaButton } from '@/components/blocks/CtaButton';
import { Title } from '@/components/common/Title';
import { desktopTitleStartPosition } from '@/components/common/utils';
import { Col, Row } from '@/components/layout/Grid';
import { Section } from '@/components/layout/Section';

import type { AlignmentOptions } from '@/components/common/Title/types';
import type { CaseStudyType } from '@/types/shared';

// Title and CtaButton alignments have different values
// In CMS, there are CtaButton values, parse them over to Title ones
const parseTitleAlignment = (
  ctaButtonAlignment: 'left' | 'center' | 'right',
): AlignmentOptions => {
  switch (ctaButtonAlignment) {
    case 'left':
      return 'start';
    case 'right':
      return 'end';
    default:
      return 'center';
  }
};

export interface CTASectionProps {
  ctaSection: CaseStudyType['ctaSection'];
  isAudienceSwitcherEnabled?: boolean;
}

export const CTASection = ({
  ctaSection: { CTA, title, alignment, buttonVariant, widthConstraint },
  isAudienceSwitcherEnabled,
}: CTASectionProps) => {
  const titleAlignment = parseTitleAlignment(alignment);
  return (
    <>
      <Section className="cta-section-title" spacing="xl">
        <Row>
          <Col
            sizes={{
              sm: widthConstraint === 'narrow' ? 8 : 12,
            }}
            start={{
              sm: desktopTitleStartPosition(widthConstraint, titleAlignment),
            }}
          >
            <Title
              {...title}
              size="sm"
              desktopAlignment={titleAlignment}
              mobileAlignment={titleAlignment}
              isNarrow={widthConstraint === 'narrow'}
            />
          </Col>
        </Row>
      </Section>
      <CtaButton
        CTA={CTA}
        alignment={alignment}
        isAudienceSwitcherEnabled={isAudienceSwitcherEnabled}
        variant={buttonVariant}
        className="cta-section-button"
        blockSpacing="sm"
      />
    </>
  );
};
